export default "__VITE_ASSET__51ded58c__"